import React, { useEffect, useMemo, useRef, useState } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axiosInstance from '../../../axios';
import { Menu, Text, Button, Paper } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
const Example = ({
  batch,
  state,
  district,
  year,
  scheme,
  sector,
  type,
  centre,
  generateClicked,
}) => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const [day, month, year] = new Date(dateString)
      .toLocaleDateString('en-GB', options)
      .split('/');
    return `${day}-${month}-${year}`;
  };
  // Date formatting function
const formatDateForExcel = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB'); // Format as dd/mm/yyyy
};
  const [batchData, setBatchData] = useState({});
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);
  const rowVirtualizerInstanceRef = useRef(null);
  const columns = useMemo(
    () => [
        {
            accessorKey: 'financial_year',
            header: 'Financial Year',
            size: 150,
        },
        {
            accessorKey: 'scheme_names',
            header: 'Scheme Names',
            size: 150,
          },
        { 
            accessorKey: 'vtp_no',
            header: 'SIP ID',
            size: 150,
          },
          {
            accessorKey: 'vtp_id',
            header: 'VTP ID',
            size: 150,
          },
          {
            accessorKey: 'centre_name',
            header: 'Centre Name',
            size: 150,
          },
          {
            accessorKey: 'TC_Capacity',
            header: 'TC Capacity',
            size: 200,
          },
          {
            accessorKey: 'centre_address',
            header: 'Centre Address',
            size: 200,
          },
          {
            accessorKey: 'state',
            header: 'State',
            size: 150,
  
          },
          {
            accessorKey: 'district',
            header: 'District',
            size: 150,
  
          },
          {
            accessorKey: 'city',
            header: 'City',
            size: 150,
  
          },
          {
            accessorKey: 'pin_code',
            header: 'Pin Code',
            size: 100,
  
          },
         
  
          {
            accessorKey: 'pmkvy_partner',
            header: 'Partner Agency',
            size: 150,
          },

          {
            accessorKey: 'cp_name',
            header: 'Contact Person Name',
            size: 150,
          },
          {
            accessorKey: 'cp_email',
            header: 'Contact Person Email',
            size: 250,
          },
          {
            accessorKey: 'cp_mo_no',
            header: 'Contact Person Mobile',
            size: 250,
          },
          {
            accessorKey:'pan_no',
            header: 'PAN No.',
            size: 150,
          },
          {
            accessorKey: 'tan_no',
            header: 'TAN No.',
            size: 150,
          },
          {
            accessorKey: 'sector_names',
            header: 'Sectors',
            size: 250,
          },
          {
            accessorKey: 'job_role_names',
            header: 'Job Role Name',
            size: 250,
          },
          {
            accessorKey: 'trainer_names',
            header: 'Trainer Name',
            size: 250,
          },
          {
            accessorKey:'Trainer_Code',
            header: 'Trainer Code',
            size: 150,
          },
          {
            accessorKey:'Trainer_Mobile',
            header: 'Trainer Contact',
            size: 150,
          },
          {
            accessorKey: 'Trainer_Address',
            header: 'Trainer Address',
            size: 150,
          },
          {
            accessorKey: 'Total_Batches',
            header: 'Total Batches',
            size: 180,
          }
        ],
        [],

  );
//console.log(batch)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post('/trainingcentre/getCenterReports', {
          scheme_id: scheme,
          financial_year: year,
          sector_id: sector,
          state,
          district,
          centre_id: centre,
          tbn_no:batch
        });
        console.log(response.data);
        setData(response.data.centers);
        setBatchData(response.data.counts);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [generateClicked]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    
  });
  const headerMapping = {
    sr_no: 'Sr No',
    financial_year:'Financial Year',
    scheme_name: 'Scheme Name',
    vtp_no:'SIP ID',
    vtp_id:'VTP ID',
    centre_name:'Centre Name',
    TC_Capacity:'TC Capacity',
    centre_address:'Centre Address',
    state:'State',
    district:'District',
    city:'City',
    pin_code:'Pin Code',
    pmkvy_partner:'Partner Agency',
    cp_name:'Contact Person Name',
    cp_email:'Contact Person Email',
    cp_mo_no:'Contact Person Mobile',
    pan_no:'PAN No.',
    tan_no:'TAN No.',
    sector_names:'Sectors',
    job_role_names:'Job Role Name',
    trainer_names:'Trainer Name',
    Trainer_Code:'Trainer Code',
    Trainer_Mobile:'Trainer Contact',
    Trainer_Address:'Trainer Address',
    Total_Batches:'Total Batches'
    
  };
  const exportToExcel = () => {
    const exportData = table.getFilteredRowModel().rows.map(({ original }, index) => ({
      sr_no: index+1,
      financial_year: original.financial_year,
      scheme_name: original.scheme_names,
        vtp_no: original.vtp_no,
        vtp_id: original.vtp_id,
        centre_name: original.centre_name,
        TC_Capacity: original.TC_Capacity,
        centre_address: original.centre_address,
        state: original.state,
        district: original.district,
        city: original.city,
        pin_code: original.pin_code,
        pmkvy_partner: original.pmkvy_partner,
        cp_name: original.cp_name,
        cp_email: original.cp_email,
        cp_mo_no: original.cp_mo_no,
        pan_no: original.pan_no,
        tan_no: original.tan_no,
        sector_names: original.sector_names,
        job_role_names: original.job_role_names,
        trainer_names: original.trainer_names,
        Trainer_Code: original.Trainer_Code,
        Trainer_Mobile: original.Trainer_Mobile,
        Trainer_Address: original.Trainer,
        Total_Batches: original.Total_Batches

    }));
    const ws = XLSX.utils.json_to_sheet(exportData, { header: Object.keys(headerMapping) });
    ws['!cols'] = Object.keys(headerMapping).map(() => ({ wpx: 120 })); // Set column widths
    const newHeaders = Object.values(headerMapping);
    newHeaders.forEach((header, index) => {
      ws[XLSX.utils.encode_cell({ r: 0, c: index })].v = header;
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'TC Report');
    XLSX.writeFile(wb, 'TC_Report.xlsx');
  };
  return (
    <Paper shadow="sm" p="lg" withBorder>
      <div className="flex justify-between mb-2">
        <Text weight={500} size="lg" className="text-sky-700">
          Total Centers : {batchData.Total_Centres}
        </Text>
        <Button color='green' onClick={exportToExcel}>Export to Excel</Button>
      </div>
      <div className="flex justify-between">    
        {/* <Text className="text-gray-600">Created: {batchData.created_batches}</Text>
        <Text className="text-green-600">Assessment Completed: {batchData.assessment_completed_batches}</Text>
        <Text className="text-yellow-600">InProgress Batches: {batchData.in_progress_batches}</Text>
        <Text className="text-lime-600">Placement Completed: {batchData.placement_completed_batches}</Text>
        <Text className="text-rose-600">Under Assessment: {batchData.under_assessment_batches}</Text> */}
      </div>

      <MantineReactTable
        table={table}
        striped
        highlightOnHover
        horizontalSpacing="md"
        verticalSpacing="sm"
        fontSize="sm"
        withColumnBorders
        borderRadius="md"
        withGlobalFilter
        height={400}
        rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
        enablePagination={true}
      />
    </Paper>
  );
};

export default Example;
